import { z } from 'zod/v4';
import { createQuery } from '@shared/lib/query-helpers';

export const warehouseDirectorySearchSchema = z
  .object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
    search: z.string().trim().max(200).optional(),
  })
  .strict();

export type WarehouseDirectorySearch = z.infer<typeof warehouseDirectorySearchSchema>;

export const warehouseDirectoryResponseSchema = z.object({
  items: z
    .array(
      z.object({
        id: z.string(),
        name: z.string().nullable(),
        code: z.string().nullable(),
        isPrimary: z.boolean().nullable(),
        isStore: z.boolean().nullable(),
        isMobileWarehouse: z.boolean().nullable(),
      })
    )
    .max(1000),
  total: z.number().int().nonnegative(),
});

export type WarehouseDirectoryItem = z.infer<
  typeof warehouseDirectoryResponseSchema
>['items'][number];

export const warehouseDirectoryKeys = {
  list: (scope: string) => ['warehouse-directory', scope] as const,
};

/** Reads the existing PostgreSQL Storehouse mirror; never starts synchronization. */
export function warehouseDirectoryQuery(scope: string) {
  return createQuery({
    path: '/api/v1/warehouse/directory',
    queryKey: warehouseDirectoryKeys.list(scope),
    schema: warehouseDirectoryResponseSchema,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    consumeAbortSignal: true,
  });
}
